import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withHandlers, compose } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as GateSelectors from 'app/modules/gates/selectors'

import SequenceOptions from './component'

const mapStateToProps = state => ({
  smartSending: PlaybookSelectors.sequenceSmartSending(state),
  weekdaysOnly: PlaybookSelectors.sequenceWeekdaysOnly(state),
  unenrollOnReply: PlaybookSelectors.sequenceUnenrollOnReply(state),
  unenrollOnReplyByDomain: PlaybookSelectors.sequenceUnenrollDomainOnReply(state),
  isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setSmartSending: PlaybookActions.setSmartSending,
    setWeekdaysOnly: PlaybookActions.setWeekdaysOnly,
    setUnenrollOnReply: PlaybookActions.setUnenrollOnReply,
    setUnenrollOnReplyByDomain: PlaybookActions.setUnenrollOnReplyByDomain,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSmartSendingClick: props => () => {
      props.actions.setSmartSending(!props.smartSending)
    },
    onWeekdaysOnlyClick: props => () => {
      props.actions.setWeekdaysOnly(!props.weekdaysOnly)
    },
    onUnenrollOnReplyClick: props => () => {
      //when unenroll on reply is turned off, we also turn off reply by domain
      const enrollToBeSet = !props.unenrollOnReply
      props.actions.setUnenrollOnReply(enrollToBeSet)
      props.actions.setUnenrollOnReplyByDomain(enrollToBeSet ? props.unenrollOnReplyByDomain : false)

    },
    onUnenrollOnReplyByDomainClick: props => () => {
      props.actions.setUnenrollOnReply(true)
      props.actions.setUnenrollOnReplyByDomain(!props.unenrollOnReplyByDomain)
    },
  }),
)(SequenceOptions)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequenceOptions/index.js